import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["item", "index"];
import React, { forwardRef } from 'react';
import { OptionContainer } from './container';
import { HighlightedLabel } from './highlighted-label';
export var SimpleOption = /*#__PURE__*/forwardRef(function SimpleOption(_ref, ref) {
  var item = _ref.item,
      index = _ref.index,
      props = _objectWithoutProperties(_ref, _excluded);

  var label = item.label;
  return /*#__PURE__*/React.createElement(OptionContainer, _extends({}, props, {
    ref: ref,
    item: item,
    index: index
  }), /*#__PURE__*/React.createElement(HighlightedLabel, null, label));
});